export const login = (token) => {
    return {
        type: 'LOGIN',
        token
    }
}

export const logout = () => {
    return {
        type: 'LOGOUT'
    }
}

export const addToCart = (product) => {
    return {
        type: 'ADD_TO_CART',
        product
    }
}

export const removeFromCart = (index) => {
    return {
        type: 'REMOVE_FROM_CART',
        index
    }
}

export const emptyCart = (index) => {
    return {
        type: 'EMPTY_CART',
        index
    }
}

export const selectActivities = (activities, indices) => {
    return {
        type: 'SELECT_ACTIVITIES',
        activities,
        indices
    }
}

export const selectFamousActivities = (activities, indices) => {
    return {
        type: 'SELECT_FAMOUSACTIVITIES',
        activities,
        indices
    }
}

export const changeLabel = (key, value) => {
    return {
        type: 'CHANGE_LABEL',
        key,
        value
    }
}

export const changeTheme = (value) => {
    return {
        type: 'CHANGE_THEME',
        value
    }
}

export const changeUnit = (value) => {
    return {
        type: 'CHANGE_UNIT',
        value
    }
}

export const changeRouteStyle = (key, value) => {
    return {
        type: 'CHANGE_ROUTESTYLE',
        key,
        value
    }
}

export const changeTemplate = (value) => {
    return {
        type: 'CHANGE_TEMPLATE',
        value
    }
}

//________PRODUCTS
function requestProducts() {
    return {
        type: 'REQUEST_PRODUCTS'
    }
}

export function receiveProducts(json) {
    return {
        type: 'RECEIVE_PRODUCTS',
        data: json,
        receivedAt: new Date().getTime
    }
}


export function fetchProducts() {
    console.log("Fetch products")
    return dispatch => {
        console.log("Fetch2 products")
        dispatch(requestProducts());
        console.log("Fetch3 products")
        return listProducts(dispatch);
    }
}

function listProducts(dispatch) {
    console.log("List products")
    return fetch('/products.json').then(function (response) {
        return response.json();
    }).then(response => {
        return dispatch(receiveProducts(response))
    });
}
//__________ ENd PRODUCTS

function requestFamousRaces() {
    return {
        type: 'REQUEST_FAMOUSRACES'
    }
}

export function receiveFamousRaces(json) {
    return {
        type: 'RECEIVE_FAMOUSRACES',
        data: json,
        receivedAt: new Date().getTime
    }
}


export function fetchFamousRaces() {
    return dispatch => {
        dispatch(requestFamousRaces());

        return listFamousRaces(dispatch);
    }
}

function listFamousRaces(dispatch) {
    return fetch('/famousraces.json').then(function (response) {
        return response.json();
    }).then(response => {
        return dispatch(receiveFamousRaces(response))
    });
}

function requestActivities() {
    return {
        type: 'REQUEST_ACTIVITIES'
    }
}

export function receiveActivities(json) {
    return {
        type: 'RECEIVE_ACTIVITIES',
        data: json,
        receivedAt: new Date().getTime
    }
}


export function fetchActivities(access_token) {
    return dispatch => {
        dispatch(requestActivities());

        return listActivities(1, access_token, dispatch);
    }
}

function listActivities(page, access_token, dispatch) {
    return fetch('https://www.strava.com/api/v3/athlete/activities?per_page=200&page=' + page, { headers: { Authorization: 'Bearer ' + access_token } }).then(function (response) {
        return response.json();
    }).then(response => {
        console.log(response);
        if (page > 5 || response.length === 0) {

        } else {
            page = page + 1
            listActivities(page, access_token, dispatch)
            return dispatch(receiveActivities(response))
        }

    });
}

function requestActivity() {
    return {
        type: 'REQUEST_ACTIVITY'
    }
}

export function receiveActivity(json) {
    return {
        type: 'RECEIVE_ACTIVITY',
        data: json,
        receivedAt: new Date().getTime
    }
}


export function fetchActivity(id, access_token) {
    return dispatch => {
        dispatch(requestActivity());

        return getActivity(id, access_token, dispatch);
    }
}

function getActivity(id, access_token, dispatch) {
    return fetch('https://www.strava.com/api/v3/activities/' + id, { headers: { Authorization: 'Bearer ' + access_token } }).then(function (response) {
        return response.json();
    }).then(activity => {
        console.log(activity);
        /*
        keys
        time:	integer seconds
        latlng:	floats [latitude, longitude]
        distance:	float meters
        altitude:	float meters
        velocity_smooth:	float meters per second
        heartrate:	integer BPM
        cadence:	integer RPM
        watts:	integer watts
        temp:	integer degrees Celsius
        moving:	boolean
        grade_smooth:	float percent
        
        resolution
        low (100), medium (1000) or high (10000), default is all, 
        */
        fetch('https://www.strava.com/api/v3/activities/' + id + "/streams?keys=distance,time,velocity_smooth,heartrate,altitude&resolution=medium&key_by_type=true", { headers: { Authorization: 'Bearer ' + access_token } }).then(function (response) {
            return response.json();
        }).then(streams => {
            console.log(streams);
            activity.streams = streams;
            return dispatch(receiveActivity(activity))
        });
    });
}

function requestFamousRace() {
    return {
        type: 'REQUEST_FAMOUSRACE'
    }
}

export function receiveFamousRace(json) {
    return {
        type: 'RECEIVE_FAMOUSRACE',
        data: json,
        receivedAt: new Date().getTime
    }
}


export function fetchFamousRace(id) {
    return dispatch => {
        dispatch(requestFamousRace());

        return getFamousRace(id, dispatch);
    }
}

function getFamousRace(id, dispatch) {
    return fetch('/famousraces/' + id + '.json').then(function (response) {
        return response.json();
    }).then(activity => {
        console.log(activity);
        return dispatch(receiveActivity(activity))
    });
}


function requestFullConfig() {
    return {
        type: 'REQUEST_FULLCONFIG'
    }
}

export function receiveFullConfig(json) {
    return {
        type: 'RECEIVE_FULLCONFIG',
        data: json,
        receivedAt: new Date().getTime
    }
}


export function fetchFullConfig(orderId, posterId) {
    return dispatch => {
        dispatch(requestFullConfig());

        return getFullConfig(orderId, posterId, dispatch);
    }
}

function getFullConfig(orderId, posterId, dispatch) {
    return fetch(global.serverUrl + '/orders/' + orderId + '/config_' + posterId + '.json').then(function (response) {
        return response.json();
    }).then(fullConfig => {
        console.log(fullConfig);
        return dispatch(receiveFullConfig(fullConfig))
    });
}


// WEBPACK FOOTER //
// ./src/actions/index.js